import React from "react";
import LazyImage from "../components/LazyImage";
import BookingForm from "../components/BookingForm";



const galleryImages = [
    "/ElgoMain.png",
    "/elgro-inn-hotel (6.1).jpg",
    "/image7.png",
    "/image3.png",
    "/image5.png",
    "/elgro-inn-hotel-5.jpg",
    "/elgro-inn-hotel-1.jpg",
];

const ElgroInnHotel = () => {
    return (
        <div className="bg-[#F2F1F0] text-[#144E73] font-sans min-h-screen pt-16 pb-20 px-6">
            <div className="max-w-6xl mx-auto">
                {/* Title */}
                <h1 className="text-4xl md:text-5xl font-bold text-primarymb-10 text-center">
                    Bothaville - Elgro Inn Hotel
                </h1>

                {/* Gallery + Description */}
                <div className="grid md:grid-cols-2 gap-10 mb-16 items-start">
                    {/* Gallery */}
                    <div className="grid grid-rows-[auto_1fr] gap-4">
                        {/* Main Image */}
                        <div className="aspect-[16/9] rounded-lg overflow-hidden border-4 border-[#FEB339]">
                            <LazyImage
                                src={galleryImages[0]}
                                alt="Elgro Inn Hotel Main View"
                                className="w-full h-full object-cover"
                            />
                        </div>

                        {/* Smaller Images */}
                        <div className="grid grid-cols-2 gap-4">
                            {galleryImages.slice(1).map((src, i) => (
                                <div
                                    key={i}
                                    className="aspect-[4/3] rounded-lg overflow-hidden border-4 border-[#FEB339]"
                                >
                                    <LazyImage
                                        src={src}
                                        alt={`Elgro Inn Hotel image ${i + 1}`}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Description */}
                    <div>
                        <p className="text-lg leading-relaxed mb-4">
                            Elgro Inn Hotel is a landmark destination in Bothaville, known for its welcoming atmosphere, family-friendly amenities, and comfortable rooms. With a variety of room types available, from singles to hunter's suites, the hotel is ideal for both business and leisure travelers.
                        </p>
                        <ul className="list-disc ml-5 text-sm space-y-2">
                            <li>DSTV & Telephone in rooms</li>
                            <li>Laundry and secretarial services</li>
                            <li>Secure parking on site</li>
                            <li>Conference facilities</li>
                            <li>Walkable distance from key local attractions</li>
                        </ul>

                        {/* Origin Story */}
                        <div className="bg-white rounded-xl border border-[#1D4E80] p-6 mt-8 shadow">
                            <h2 className="text-2xl font-semibold text-primarymb-3">The Story Behind the Name</h2>
                            <p className="text-sm leading-relaxed">
                                The name <strong className="text-[#FEB339]">E</strong>
                                <strong className="text-[#FEB339]">L</strong>
                                <strong className="text-[#FEB339]">G</strong>
                                <strong className="text-[#FEB339]">R</strong>
                                <strong className="text-[#FEB339]">O</strong> is more than just a brand — it’s a tribute to the women who helped build the Benecke family legacy. Each letter in <strong className="text-[#FEB339]">ELGRO</strong> comes from the first name of a remarkable woman:
                            </p>
                            <ul className="list-disc pl-5 my-4 text-sm">
                                <li><strong className="text-[#FEB339]">E</strong>lsa</li>
                                <li><strong className="text-[#FEB339]">L</strong>ettie</li>
                                <li><strong className="text-[#FEB339]">G</strong>rieta</li>
                                <li><strong className="text-[#FEB339]">R</strong>ita</li>
                                <li><strong className="text-[#FEB339]">O</strong>na</li>
                            </ul>
                            <p className="text-sm">
                                This special combination of names reflects the warmth and strength behind the business. The story was featured in <em>Die Huisgenoot</em> in December 1967 — a beautiful beginning for a beloved hotel.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Booking Form */}

                <BookingForm hotelName="Elgro Inn Hotel"/>

            </div>
        </div>
    );
};

export default ElgroInnHotel;
